var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("项目合同")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "border": "1px solid #eaebed"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-left": "2%",
      "padding-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("合同名称 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.condition.contract_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "contract_name", $$v)
      },
      expression: "condition.contract_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.AddFrom
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 3% 0 3%"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "height": "574px",
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope_1.$index + 1) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contract_code",
      "align": "center",
      "label": "合同编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contract_name",
      "align": "center",
      "label": "合同名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "series",
      "align": "center",
      "label": "系列"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "industry_andInnovation",
      "align": "center",
      "label": "业务板块"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "first_party",
      "align": "center",
      "label": "甲方"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "second_party",
      "align": "center",
      "label": "乙方"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time_on",
      "align": "center",
      "label": "开始时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time_end",
      "align": "center",
      "label": "结束时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit_price",
      "align": "center",
      "label": "单价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "align": "center",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "monthly_total",
      "align": "center",
      "label": "月合计"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "annual_total",
      "align": "center",
      "label": "年合计"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "page_number",
      "align": "center",
      "label": "页码数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contractual_accounting_period",
      "align": "center",
      "label": "合同约定账期",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "performance_bond",
      "align": "center",
      "label": "履约金"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expired_renewed",
      "align": "center",
      "label": "到期未续签",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.expired_renewed < -90),
            expression: "scope.row.expired_renewed < -90 "
          }],
          class: 'green'
        }, [_vm._v("未到期")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.expired_renewed > -90 && scope.row.expired_renewed < 0),
            expression: "scope.row.expired_renewed > -90 && scope.row.expired_renewed < 0 "
          }],
          class: 'orange'
        }, [_vm._v("即将到期")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.expired_renewed >= 0),
            expression: "scope.row.expired_renewed >= 0 "
          }],
          class: 'red'
        }, [_vm._v("已到期，请续签。")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "notes",
      "align": "center",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "fixed": "right",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/编辑.png")
          },
          on: {
            "click": function($event) {
              return _vm.UpdateFrom(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "src": require("../../../assets/删除.png")
          },
          on: {
            "click": function($event) {
              return _vm.Del(scope.row.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.from.id == null || _vm.from.id == '' ? '添加项目合同' : '修改项目合同',
      "visible": _vm.dialogVisible,
      "width": "60%",
      "close-on-click-modal": false,
      "center": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "from",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同编码",
      "prop": "contract_code"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.contract_code),
      callback: function($$v) {
        _vm.$set(_vm.from, "contract_code", $$v)
      },
      expression: "from.contract_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同名称",
      "prop": "contract_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.contract_name),
      callback: function($$v) {
        _vm.$set(_vm.from, "contract_name", $$v)
      },
      expression: "from.contract_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "系列",
      "prop": "series_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.from.series_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "series_id", $$v)
      },
      expression: "from.series_id"
    }
  }, _vm._l((_vm.seriesList), function(series) {
    return _c('el-option', {
      key: series.id,
      attrs: {
        "label": series.data,
        "value": series.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务板块",
      "prop": "andInnovation_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.from.andInnovation_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "andInnovation_id", $$v)
      },
      expression: "from.andInnovation_id"
    }
  }, _vm._l((_vm.sectorList), function(sector) {
    return _c('el-option', {
      key: sector.id,
      attrs: {
        "label": sector.data,
        "value": sector.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "甲方",
      "prop": "first_party"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.first_party),
      callback: function($$v) {
        _vm.$set(_vm.from, "first_party", $$v)
      },
      expression: "from.first_party"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "乙方",
      "prop": "second_party"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.second_party),
      callback: function($$v) {
        _vm.$set(_vm.from, "second_party", $$v)
      },
      expression: "from.second_party"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "time_on"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.from.time_on),
      callback: function($$v) {
        _vm.$set(_vm.from, "time_on", $$v)
      },
      expression: "from.time_on"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "time_end"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.from.time_end),
      callback: function($$v) {
        _vm.$set(_vm.from, "time_end", $$v)
      },
      expression: "from.time_end"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单价",
      "prop": "unit_price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.from.unit_price),
      callback: function($$v) {
        _vm.$set(_vm.from, "unit_price", $$v)
      },
      expression: "from.unit_price"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数量",
      "prop": "number"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.from.number),
      callback: function($$v) {
        _vm.$set(_vm.from, "number", $$v)
      },
      expression: "from.number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "月合计",
      "prop": "monthly_total"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.monthly_total),
      callback: function($$v) {
        _vm.$set(_vm.from, "monthly_total", $$v)
      },
      expression: "from.monthly_total"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "年合计",
      "prop": "annual_total"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.annual_total),
      callback: function($$v) {
        _vm.$set(_vm.from, "annual_total", $$v)
      },
      expression: "from.annual_total"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "页码数",
      "prop": "page_number"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.page_number),
      callback: function($$v) {
        _vm.$set(_vm.from, "page_number", $$v)
      },
      expression: "from.page_number"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同约定账期",
      "prop": "contractual_accounting_period"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.contractual_accounting_period),
      callback: function($$v) {
        _vm.$set(_vm.from, "contractual_accounting_period", $$v)
      },
      expression: "from.contractual_accounting_period"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "履约金",
      "prop": "performance_bond"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.performance_bond),
      callback: function($$v) {
        _vm.$set(_vm.from, "performance_bond", $$v)
      },
      expression: "from.performance_bond"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.from.notes),
      callback: function($$v) {
        _vm.$set(_vm.from, "notes", $$v)
      },
      expression: "from.notes"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "附件",
      "prop": "name"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadFujian,
      "before-remove": _vm.beforeRemove,
      "multiple": "",
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList,
      "v-model": _vm.from.annex
    }
  }, [_c('el-button', {
    staticStyle: {
      "font-size": "10px",
      "width": "100px"
    },
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("上传附件")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "-10%"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.from.id == null || _vm.from.id == ''),
      expression: "from.id == null || from.id == ''"
    }],
    staticStyle: {
      "width": "15%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.from.id != null && _vm.from.id != ''),
      expression: "from.id != null && from.id != ''"
    }],
    staticStyle: {
      "width": "15%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("修改")])], 1)], 1)], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1728bffd","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/Xmht/Xmht.vue
// module id = null
// module chunks = 